import { Plugin, registerPlugin } from '@capacitor/core';
import { IntercomUserUpdateOptions } from '@capacitor-community/intercom';

export interface IntercomExtensionPlugin extends Plugin {
  updateUser(options: IntercomUserUpdateOptions): Promise<void>;
  unreadConversationCount(): Promise<{ count: number }>;
}

export interface IntercomCompany {
  companyId: string;
  name: string;
}

export interface IntercomExtensionUserUpdateOptions
  extends IntercomUserUpdateOptions {
  companies: IntercomCompany[];
}

export interface IntercomUnreadNotificationCountDidChangeEvent {
  count: number;
}

export enum IntercomExtensionEvent {
  UNREAD_CONVERSATION_COUNT_DID_CHANGE = 'unreadConversationCountDidChange',
}

const IntercomExtension = registerPlugin<IntercomExtensionPlugin>(
  'IntercomExtensionPlugin'
);

export { IntercomExtension };
